<template>
  <tr>
    <td v-if="!estaLiquidado">
      <button v-if="item.isNew" class="btn btn-xs btn-icon btn-light-danger" @click="onRemove">
        <i class="fa fa-trash-alt"></i>
      </button>
    </td>
    <td class="text-center">
      <template v-if="!item.isNew">{{ item.fecha | date }}</template>
      <InputDatepicker
        v-else
        v-model="item.fecha"
        :errorMode="'tooltip'"
        :vid="`fecha_${item.id}`"
        name="Fecha"
        rules="required"
        :editable="false"
        :inputClass="'form-control form-control-table'"
      ></InputDatepicker>
    </td>
    <td>
      <template v-if="!item.isNew">{{ item.servicio }}</template>
      <InputText
        v-else
        v-model="item.otroServicio"
        :errorMode="'tooltip'"
        :vid="`servicio_${item.id}`"
        name="Servicio"
        rules="required"
        :inputClass="'form-control form-control-table'"
      ></InputText>
    </td>
    <td>
      <template v-if="!item.isNew">{{ item.hotel }}</template>
      <InputText v-else v-model="item.otroHotel" :errorMode="'tooltip'" :vid="`hotel_${item.id}`" name="Hotel" rules="" :inputClass="'form-control form-control-table'"></InputText>
    </td>
    <td class="text-center">
      <template v-if="!item.isNew">{{ item.servicioTipo }}</template>
      <InputText
        v-else
        v-model="item.otroTipo"
        :errorMode="'tooltip'"
        :vid="`servicioTipo_${item.id}`"
        name="Tipo"
        :inputClass="'form-control form-control-table text-center'"
      ></InputText>
    </td>
    <td class="text-center">
      <template v-if="estaLiquidado">{{ item.moneda }}</template>
      <InputSelect
        v-else
        v-model="item.tempMoneda"
        :inputClass="'form-control-table text-center'"
        :options="monedas"
        :reduce="(opt) => opt.sigla"
        label="sigla"
        rules="required"
        :errorMode="'tooltip'"
        name="Moneda"
        :vid="`moneda_${item.id}`"
      ></InputSelect>
    </td>
    <td class="text-center">
      <template v-if="estaLiquidado">{{ item.tarifa | number(2) }}</template>
      <InputText
        v-else
        v-model="item.tarifa"
        :errorMode="'tooltip'"
        :vid="`tarifa_${item.id}`"
        name="Tarifa"
        rules="required|number"
        :inputClass="'form-control form-control-table text-center'"
      ></InputText>
    </td>
    <td>
      <template v-if="estaLiquidado">{{ item.observaciones }}</template>
      <InputTextArea
        v-else
        v-model="item.observaciones"
        :errorMode="'tooltip'"
        :vid="`observaciones_${item.id}`"
        :name="'Observaciones'"
        inputClass="form-control form-control-table"
      ></InputTextArea>
    </td>
  </tr>
</template>

<script>
import InputSelect from '../../shared/components/InputSelect.vue'
import InputTextArea from "../../shared/components/InputTextArea.vue";
import InputText from "../../shared/components/InputText.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import { mapGetters } from "vuex";

export default {
  components: { InputDatepicker, InputText, InputTextArea, InputSelect },
  props: {
    item: Object,
  },

  computed: {
    ...mapGetters("privado.liquidar", ["estaLiquidado", "monedas"]),
  },
  methods: {
    onRemove() {
      this.$store.dispatch("privado.liquidar/remove", this.item.id);
    },
  },
};
</script>

<style></style>
